export const isIncubatorPages = (): boolean => {
    const {pathname} = window.location;
    const incubatorLineId = /\/play\/incubator\/(?<id>\d+)/u;

    return Boolean(pathname.match(incubatorLineId)) ||
        Boolean(pathname.includes('/play/incubator/my_lines'));
};
